<template>
    <div class="turnShop">
        <div class="turnShop-main">
            <div class="nav clearfix">
                    <img class="navBack pull-left" src="../../../static/images/common/back.png" alt="" @click="navBack()">
                <h2 class="navTitle pull-left">委托转铺</h2>
            </div>

            <!-- 委托转铺头部 -->
            <div class="turnShopTop">
                <div @click="sendContent()">立即委托</div>
            </div>
            <!-- 多块好省 -->
            <div class="turnShopTop2"></div>

            <!-- 六大安心服务保障 -->
            <div class="sixWrap"></div>
            
            <!-- 委托出租 只需 5 步 -->
            <div class="fiveWrap"></div>

            <!-- 战略合作 -->
            <div class="cooperateWrap"></div>

            <!-- 委托转铺服务收费标准 -->
            <div class="chargeStandard clearfix">
                <div class="chargeStandardMain" v-for="item in vipArr">
                    <div class="chargeStandardMainDl">
                        
                        <p v-if="cityIdNum == '210100' || appCityId == '210100'">转让费/兑费</p>
                        <p v-else>年租金/转让费</p>
                        
                        <dl>
                            <dt>
                                <h4><span class="span1">{{item.dsc}}</span><span>{{item.price}}元</span></h4>
                                <h5>服务期3个月</h5>
                            </dt>
                            <dd @click="goBuyBtn(item)">立即购买</dd>
                        </dl>
                    </div>
                </div>
            </div>

            <div class="consultingTel">
                <p>服务咨询电话：010-85951005</p>
            </div>
            <!-- 底部盒子 -->
            <div class="bottomDiv"></div>
            <!-- 悬浮框 -->
            <div class="input-bottom">
                <input type="tel" name="" placeholder="请输入手机号码，专属顾问5分钟内与您联系" onfocus="this.placeholder=''" onblur="this.placeholder='请输入手机号码，专属顾问5分钟内与您联系'" maxlength="11" class="txt-input" v-model="telVal">
                <div class="wrap-input-img"><img src="../../../static/images/seekShop/seekBtn.png" alt="" @click="sumbtn()"></div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'turnShop',
    data () {
        return {
            telVal: "",
            // source: "",
            shopIndex: "",
            // 购买VIP
            vipArr: [],
            appCityId: "",
            move: "",
            appProvinceId: "",
            appAccount: "",
            appSource: "",
            cityIdNum: "", //城市ID
        }
    },
    computed:{

    },
    methods:{
        // 点击提交按钮
        sumbtn() {
            let _this = this

            // 手机号码验证
            let reg=/^[1][3,4,5,7,8,9][0-9]{9}$/;

            if(this.telVal == ""){
                layer.open({
                    content: '请输入手机号码',
                    skin: 'msg',
                    time: 2
                });
            }else if(!reg.test(this.telVal)){
                layer.open({
                    content: '请输入正确手机号',
                    skin: 'msg',
                    time: 2
                });
            }else {
                // 接口调用
                let url = _this.changeData() + '/show/addCutomer'
                axios(url,{
                    method: 'post',
                    // url: url,
                    params: {
                        // account: _this.telVal, //   委托手机号
                        // type: '1', // 0 委托找铺 1 委托转铺
                        // provinceId: sessionStorage.provinceId, // 省id
                        // cityId: sessionStorage.cityId, // 市id
                        // source: "3", // 渠道 0 Android 1 IOS 2 官网 3 M站

                        account: _this.telVal || _this.appAccount, //委托手机号
                        type: '1', // 0 委托找铺 1 委托转铺
                        provinceId: _this.appProvinceId || sessionStorage.provinceId, // 省id
                        cityId: _this.appCityId || sessionStorage.cityId, // 市id
                        source: _this.appSource || "3", // 渠道 0 Android 1 IOS 2 官网 3 M站
                    }
                    // params: obj
                }).then(data => {
                    if(data.data.code == 101){
                        layer.open({
                          content: data.data.msg,
                          skin: 'msg',
                          time: 4
                        });
                        _this.telVal = "";
                    }else{
                        ayer.open({
                          content: '系统繁忙，请稍后再试',
                          skin: 'msg',
                          time: 4
                        });
                    }
                }).catch(err => {
                    console.log(err)
                });
            }
        },
        navBack(){
            // this.$router.go(-1);
            if(this.shopIndex){
                this.$router.push({path:"/shopDetail",query:{shopId: this.shopIndex}});
            }else if(this.$route.query.lookShop){
                this.$router.push({path: '/lookShop'});
            }else{
                this.$router.push({path: '/home'});
            }
        },
        sendContent(){
            if(this.move == "ios"){
                window.location.href="seekshopbtn://";
            }else{
                $(".txt-input").focus();
            }
        },
        // 去支付页面
        goBuyBtn(item){
            if(this.move == "ios"){
                window.location.href="turnshop://" + item.id;
            }else if(this.move == "android"){
                return AndroidBuy.showToast(item.id);
            }else{
                let isLogin = window.localStorage.getItem("iphone");
                if(isLogin){
                    this.$router.push({path:"/payment",query:{"id":item.id,"price":item.price,"turnShop":"1"}});
                }else{
                    this.$router.push({path:"/login",query:{"id":item.id,"price":item.price,"urlType":"turnShop"}});
                }
            }
        },
        // 获取产品信息
        memberData(){
            // 接口调用
            let _this = this;
            let url = _this.changeData() + '/member/selectProductList'
            axios(url,{
                method: 'post',
                // url: url,
                params: {
                    type: '2', // 0 找铺会员 4 转铺会员 1 VIP选址服务 2 VIP转铺服务
                    cityId: this.appCityId || sessionStorage.cityId, // 市id
                }
            }).then(data => {
                // console.log(data);
                this.vipArr = data.data.productList;
            }).catch(err => {
                console.log(err)
            });
        }
    },
    mounted() {
        //截取Url里面的参数
        function GetRequest() {
            var url = location.search; //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
        //通过url取数
        var request = new Object();
        request = GetRequest();
        // var urlId = request['id'];
        var urlIndex = request['url'];
        var shopId = request['shopId'];
        this.shopIndex = shopId;

        this.appCityId = request['cityId'];
        this.move = request['move'];
        this.appProvinceId = request['provinceId'];
        this.appAccount = request['account'];
        this.appSource = request['source'];

        if(this.move == "ios"){
            $(".input-bottom").hide();
        }else if(this.move == "android"){
            $(".nav").hide();
        }

        if(sessionStorage.cityId){
            this.cityIdNum = sessionStorage.cityId;
        }


        // if(sessionStorage.cityId || this.appCityId){
        //     this.memberData();
        // }else{
        //     history.go(0);
        // }

        let _this = this;
        setTimeout(function () {
           _this.memberData();
        },500)



        // 获取产品信息
        // this.memberData();

        // if(urlId){
        //     this.source = urlId;
        //     $(".nav").hide();
        // }
        
        if(urlIndex){
            this.telVal = urlIndex;
        }

        let USERS = window.localStorage.getItem("iphone");
        if(USERS){
            this.telVal = USERS
        }
        if(this.move == "android"){
            this.telVal = this.appAccount;
        }
    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.pull-right{
    float: right;
}
.pull-left{

    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color: #fff;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #fff;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #fff;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:  #fff;
}

.main{
    width: 7.5rem;
    margin: 0 auto;
    background: #f0eff6;
    position: absolute;
    top: 0;
    bottom: 0rem;
    padding-bottom: .5rem;
}
/*导航*/
.nav{
    width: 7.1rem;
    height: 1rem;
    background: #fff;
    margin:0 auto;
    padding: 0rem 0.2rem 0 0.2rem;
    border-bottom: 0.02rem solid #eee;
    position: fixed;
    top: 0;
    z-index: 10000;
}
.nav a{
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.navBack{
    width: 0.32rem;
    height: 0.36rem;
    margin-top: 0.3rem;
}
.navTitle{
    height: 1rem;
    width: 6.4rem;
    line-height: 1rem;
    font-size: 0.36rem;
    color: #111;
    text-align: center;
}
.turnShop-main{
    width: 7.5rem;
    margin: 0 auto;
    background: #f0eff6;
    position: absolute;
    top: 0;
    bottom: 0rem;
    padding-bottom: 1rem;
}
.turnShopTop{
    width: 7.5rem;
    height: 6.86rem;
    background: url("../../../static/images/turnShop/turnShopTop.png") no-repeat top center;
    background-size: 7.5rem 6.86rem;
    position: relative;
    div{
        width: 3.66rem;
        height: .84rem;
        background: #2F7AF7;
        border-radius: 42px;
        position: absolute;
        bottom: .88rem;
        left: -1.83rem;
        margin-left: 50%;
        text-align: center;
        line-height: .84rem;
        color: #fff;
        font-size: .36rem;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
}

/*多块好省*/
.turnShopTop2{
    width: 7.5rem;
    height: 6.2rem;
    background: #fff;
    background: url("../../../static/images/turnShop/duo.png") no-repeat top center;
    background-size: 7.5rem 6.2rem;
}

/*六大安心服务保障*/
.sixWrap{
    width: 7.5rem;
    height: 5.3rem;
    background: #fff;
    background: url("../../../static/images/turnShop/six.png") no-repeat top center;
    background-size: 7.5rem 5.3rem;
}

/*委托出租 只需5步*/
.fiveWrap{
    width: 7.5rem;
    height: 6.12rem;
    background: #fff;
    background: url("../../../static/images/turnShop/five.png") no-repeat top center;
    background-size: 7.5rem 6.12rem;
}

/*战略合作*/
.cooperateWrap{
    width: 7.5rem;
    height: 3.86rem;
    background: #fff;
    background: url("../../../static/images/turnShop/cooperate.png") no-repeat top center;
    background-size: 7.5rem 3.86rem;
}

/*购买Vip*/
.chargeStandard{
    width: 7.5rem;
    background: #fff;   
    .chargeStandardMainDl{
        width: 3.44rem;
        height: 3.24rem;
        background: #FBF5F5;
        border: 1px solid #DF4646;
        border-radius: 6px;
        box-sizing: border-box;
        float: left;
        margin-left: .2rem;
        margin-bottom: .2rem;
        p{
            height: .6rem;
            background: #DF4646;
            color: #fff;
            text-align: center;
            font-size: .3rem;
            line-height: .6rem;
            border-radius: 4px 4px 0px 0px;
        }
        dl{
            dt{
                text-align: center;
                h4{
                    color: #333333;
                    font-size: .28rem;
                    margin-top: .28rem;
                    margin-bottom: .18rem;
                    .span1{
                        margin-right: .2rem;
                    }
                }
                h5{
                   color: #333333;
                    font-size: .28rem;
                    line-height: .3rem;
                }
            }
            dd{
                width: 2.08rem;
                height: .78rem;
                background: #2F7AF7;
                border-radius: 30px;
                -webkit-tap-highlight-color: rgba(0,0,0,0);
                color: #fff;
                font-size: .3rem;
                line-height: .78rem;
                text-align: center;
                margin: .4rem auto 0;
            }
        }
    }
}
/*客服电话*/
.consultingTel{
    width: 7.5rem;
    background: #fff;
    padding-top: .5rem;
    padding-bottom: .55rem;
    p{
        color: #333;
        font-size: .28rem;
        text-align: center;
    }
}
/*底部输入框*/
.input-bottom{
    width: 7.5rem;
    height: 1.3rem;
    position: fixed;
    bottom: 0px;
    background: #fff;
    box-shadow:0px 0px 2px #64ABFF;
    input{
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        width: 68%;
        height: 0.9rem;
        border-radius: 10px;
        margin-left: 6%;
        float: left;
        font-size: .24rem;
    }
}
.txt-input{
    margin-top: 0.2rem;
    font-size: 0.3rem;
    background: #64ABFF;
    text-indent: 0.2rem;
    color: #fff;
    float: left;
}
.wrap-input-img{
    width: 18%;
    margin-left: 2%;
    float: left;
    margin-top: 0.2rem;
    img{
        width: 100%;
        height: .9rem;
    }
}
/*底部盒子*/
.bottomDiv{
    height: 1.3rem;
    width: 7.5rem;
    background: #f7f8fa;
}
</style>




// WEBPACK FOOTER //
// src/components/home/turnShop.vue